// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"512":"f7aabcf200df2913","575":"83b60a0ab47c3388","729":"7cf61cd5c38d1c65","783":"b3ee76d1ec1272a1","796":"4275684043747ae4"}[chunkId] + ".js";
};